<template>
  <b-modal ref="mainModal" size="xl" hide-footer modal-class="image-viewer-modal" :title="getTitle" @hide="onModalHide">
    <template v-slot:default="{ hide }">
      <div class="image-viewer">
        <div class="row">
          <div class="col-md-12" v-if="items.length > 0">
            <div class="image-viewer-active-image-wrapper">
              <div class="inner-wrapper">
                <b-embed
                    v-if="items[activeIndex] && items[activeIndex].data && items[activeIndex].data.main" controls
                    allowfullscreen :src="items[activeIndex].data.main.url"/>
                <img v-else :src="getImageUrl(items[activeIndex], 'lg')"/>
              </div>
            </div>
          </div>
        </div>
        <div class="thumbnails" :class="{'mr-4 ml-4' : isScrollable}" :style="getImageStyle" ref="slider">
          <div class="thumbnail-wrapper" v-for="(item, index) in items" :key="item.uuid">
            <div class="inner-wrapper" :class="{active: activeIndex === index}" @click="activeIndex = index">
              <b-tooltip :target="`viewer-thumb-${item.uuid}`" :title="getImageDisplayName(item)"
                         :disabled="!getImageDisplayName(item)"/>
              <div :id="`viewer-thumb-${item.uuid}`" class="image-placeholder d-flex align-items-center">
                <font-awesome-icon v-if="item.data && item.data.main" style="font-size: 4em" icon="file-video"/>
                <img v-else :src="getImageUrl(item, 'thumb')"/>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-arrow left-arrow mr-5" v-if="isScrollable" @click="scrollLeft">
          <font-awesome-icon class="icon" icon="chevron-left"/>
        </div>
        <div class="carousel-arrow right-arrow" v-if="isScrollable" @click="scrollRight">
          <font-awesome-icon class="icon" icon="chevron-right"/>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import Vue from 'vue';

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: 'ImageViewer',
    data() {
      return {
        activeIndex: 0,
        items: [],
        title: '',
        windowWidth: window.innerWidth,
      }
    },
    methods: {
      show({items, title}) {
        this.activeIndex = 0;
        document.addEventListener('keydown', this.onKeydown);
        this.items = items;
        this.title = title;
        this.$refs.mainModal.show();
      },
      getImageUrl(item, size) {
        if (Object.keys(item.data).length) {
          if (item.data[size]) {
            return item.data[size].url;
          }
          return item.data['original'].url;
        } else {
          return item.base64
        }
      },
      onKeydown(e) {
        let index = this.activeIndex;
        if (e.key === 'ArrowLeft') {
          index--;
          if (index < 0) {
            index = this.activeIndex;
          }
          if (index > this.visibleItemsLength - 1) {
            this.scrollLeft();
          }
        } else if (e.key === 'ArrowRight') {
          index++;
          if (index > this.items.length - 1) {
            index = this.activeIndex;
          }
          if (index > this.visibleItemsLength - 1) {
            this.scrollRight();
          }
        }
        this.activeIndex = index;
        e.preventDefault();
      },
      onModalHide() {
        document.removeEventListener('keydown', this.onKeydown);
      },
      scrollLeft() {
        this.$refs.slider.scrollLeft -= 112;
      },
      scrollRight() {
        this.$refs.slider.scrollLeft += 112;
      },
      getImageDisplayName(item) {
        if (item.original_filename) {
          return item.original_filename;
        }
        if (item.file && item.file.name) {
          return item.file.name;
        }
        return '';
      },
    },
    computed: {
      getTitle() {
        let returnString = Vue.filter('striptags')(this.title);
        returnString = Vue.filter('truncate')(returnString, 50);
        return returnString;
      },
      isSmallScreen() {
        return this.windowWidth <= 991;
      },
      getImageStyle() {
        return this.isSmallScreen || this.items.length > this.visibleItemsLength ?
            {flexWrap: 'unset', overflow: 'auto'} : {justifyContent: 'center'};
      },
      visibleItemsLength() {
        return this.windowWidth > 1200 ? 9 : this.windowWidth > 991 ? 5 : 3;
      },
      isScrollable() {
        return this.items.length > this.visibleItemsLength && !this.isSmallScreen;
      },
    },
    mounted() {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth;
      })
    }
  };
</script>

<style lang="scss" src="./index.scss">
</style>

<style lang="scss" scoped>
  .carousel-arrow {
    background: #ffffff;
    font-size: 20px;
    cursor: pointer;
    padding: 38px 13px;
  }

  .right-arrow {
    position: absolute;
    bottom: 30px;
    right: 0;
  }

  .left-arrow {
    position: absolute;
    bottom: 30px;
    left: 0;
  }

  ::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }
</style>
